import React, { useLayoutEffect, useRef } from "react";
import "./webaudio-controls/webaudio-controls-module";
export const WebAudioSwitch = (props) => {
    const ref = useRef(null);
    useLayoutEffect(() => {
        const { current } = ref;
        if (current !== undefined) {
            // @ts-ignore
            current === null || current === void 0 ? void 0 : current.addEventListener("click", (event) => {
                props.onSwitchClick && (props === null || props === void 0 ? void 0 : props.onSwitchClick(event.target.value));
                props.onSwitchClickEvent && (props === null || props === void 0 ? void 0 : props.onSwitchClickEvent(event));
            });
            // @ts-ignore
            current === null || current === void 0 ? void 0 : current.addEventListener("change", (event) => {
                props.onSwitchChange && (props === null || props === void 0 ? void 0 : props.onSwitchChange(event.target.value));
                props.onSwitchChangeEvent && (props === null || props === void 0 ? void 0 : props.onSwitchChangeEvent(event));
            });
        }
    }, [ref]);
    // @ts-ignore
    return (React.createElement("webaudio-switch", { id: (props === null || props === void 0 ? void 0 : props.id) ? props.id : "switch", ref: ref, ...props }));
};
